<template>
	<div  class="home">
		<div class="col-md-offset-1 col-md-10">
			<div class="panel panel-default drop-shadow">
				<div class="panel-heading panel-grey text-left">
					CONTACT US
				</div>

				<div style="padding:5px; text-align:left;">
					Contact information will appear here.
					<br><br>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

export default {
	name: 'terms',

	components: {
	},
	
	data() {
		return {
			env: process.env.VUE_APP_ENV,
		}
	},
	
	created() {
	},

	mounted() {
	},

	destroyed() {
	},

	methods: {
	},
}

</script>
